import {css} from 'lit';
export const styles = css`:host {
  --background: var(--contrast-light);
  --color: var(--contrast-dark);

  display: block;
  font-size: var(--font-size);
  font-weight: 700;
}

a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 16px;
  background-color: var(--background);
  color: var(--text-primary);
  border-radius: var(--border-radius);
}

a ef-avatar {
    --avatar-size: 43px;

    margin-right: 8px;
    flex-shrink: 0;
  }

@media (hover: hover) {
  a:hover {
    --link-text-hover: var(--color);
    --background: var(--gray-200);
  }
}

a:active {
  --link-text-active: var(--color);
  --background: var(--gray-300);
}
`;
export default styles;
